import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SliderNavigation from './SliderNavigation';
import { useLanguage } from '../contexts/LanguageProvider';

const ContentSlider = ({ title, children, slidesPerView = 'auto', spaceBetween = 20 }) => {
  const language = useLanguage();
  const swiperRef = useRef(null);
  const [canGoPrev, setCanGoPrev] = useState(false);
  const [canGoNext, setCanGoNext] = useState(true);

  const updateNavigationState = (swiper) => {
    setCanGoPrev(!swiper.isBeginning);
    setCanGoNext(!swiper.isEnd);
  };

  return (
    <section className='content-section mt-10'>
      <div className='flex justify-between items-center mb-5'>
        <h2>{title}</h2>

        <div className='flex gap-3'>
          <div className='p-2 tag-background dim rounded'>
            <span>{language.t('allGames')}</span>
          </div>

          <SliderNavigation 
            canGoPrev={canGoPrev}
            canGoNext={canGoNext}
            onPrevClick={() => swiperRef.current?.slidePrev()}
            onNextClick={() => swiperRef.current?.slideNext()}
          />
        </div>
      </div>

      <Swiper
        slidesPerView={slidesPerView}
        spaceBetween={spaceBetween}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
          updateNavigationState(swiper);
        }}
        onSlideChange={(swiper) => updateNavigationState(swiper)}
      >
        {children}
      </Swiper>
    </section>
  );
};

export default ContentSlider;